import styled from "styled-components"
import { Row } from "react-bootstrap"

export const StyledIssueRow = styled(Row)`
    padding-right: 7.5px;
    padding-left: 7.5px;
`
